<template>
  <div>
    <div class="banner">
      <div class="headerReplacementStockPriceInfo"></div>
      <div class="banner-text">
        <b>ข้อมูลราคาหลักทรัพย์</b>
        <div class="breadcrumb">
          <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
          <span class="separator"></span>
          <span>ข้อมูลราคาหลักทรัพย์</span>
          <span class="separator"></span>
          <span><b>เครื่องคำนวณการลงทุน</b></span>
        </div>
      </div>
    </div>

    <div class="container ">
      <div class="TabMenu">
        <StockPriceInfoTabMenu />
      </div>
      <div class="row mt-4 mb-5">
        <div class="col-md-6">
          <div class="card bg-white">
            <div class="card-header bg-black text-white">
              ระยะเวลา
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="m-1">จาก</label>
                  <date-picker type="date" placeholder="วันที่เริ่ม" class="w-100" input-class="form-control"
                    value-type="format" format="YYYY-MM-DD" />
                </div>
                <div class="col-md-6">
                  <label class="m-1">ถึง</label>
                  <date-picker type="date" placeholder="วันที่สิ้นสุด" class="w-100" input-class="form-control"
                    value-type="format" format="YYYY-MM-DD" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card bg-white">
            <div class="card-header bg-black text-white">
              การลงทุน
            </div>
            <div class="card-body">
              <div class="row mb-3">
                <div class="col-md-6">
                  <input class="form-check-inpu m-1" type="radio">
                  <label class="form-check-label m-1">
                    จำนวนเงิน
                  </label>
                  <input class="form-control" type="text">
                </div>
                <div class="col-md-6">
                  <input class="form-check-input m-1" type="radio">
                  <label class="form-check-label m-1">
                    จำนวนหุ้น
                  </label>
                  <input class="form-control" type="text">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <table class="table text-center">
        <thead>
          <tr>
            <th scope="col"><b>ราคาซื้อ</b></th>
            <th scope="col"><b>ราคาขาย</b></th>
            <th scope="col"><b>จำนวนหุ้น (โดยประมาณ)</b></th>
            <th scope="col"><b>มูลค่าการซื้อ</b></th>
            <th scope="col"><b>มูลค่าการขาย</b></th>
            <th scope="col"><b>ผลกำไรส่วนต่าง</b></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
        </tbody>
      </table>

      <!-- Intraday Chart Container -->
      <div class="card bg-white mt-4 mb-5">
        <div ref="chartContainer" class="chart-container"></div>
      </div>


    </div>
  </div>
</template>
  
<script>
import StockPriceInfoTabMenu from '@/components/StockPriceInfoTabMenu.vue';
import Highcharts from 'highcharts/highstock';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";
import DatePicker from 'vue2-datepicker';

export default {
  name: 'Info',
  components: {
    StockPriceInfoTabMenu, DatePicker
  },
  data() {
    return {
      stockData: [
        [Date.UTC(2023, 9, 1, 9, 0), 5.95],
        [Date.UTC(2023, 9, 1, 10, 0), 6.05],
        [Date.UTC(2023, 9, 1, 11, 0), 6.15],
        [Date.UTC(2023, 9, 1, 12, 0), 6.08],
        [Date.UTC(2023, 9, 1, 13, 0), 6.12],
        [Date.UTC(2023, 9, 1, 14, 0), 6.10],
        [Date.UTC(2023, 9, 1, 15, 0), 6.05],
      ]
    };
  },
  mounted() {
    Highcharts.stockChart(this.$refs.chartContainer, {
      title: {
        text: 'AAPL stock price by minute'
      },
      subtitle: {
        text: 'Using ordinal X axis'
      },
      xAxis: {
        gapGridLineWidth: 0
      },
      rangeSelector: {
        buttons: [{
          type: 'hour',
          count: 1,
          text: '1h'
        }, {
          type: 'day',
          count: 1,
          text: '1D'
        }, {
          type: 'all',
          count: 1,
          text: 'All'
        }],
        selected: 1,
        inputEnabled: false
      },
      series: [{
        name: 'AAPL',
        type: 'area',
        data: this.stockData,
        gapSize: 5,
        tooltip: {
          valueDecimals: 2
        },
        fillColor: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, Highcharts.getOptions().colors[0]],
            [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
          ]
        },
        threshold: null
      }]
    });
  }
};
</script>
<style scoped>
th {
  font-weight: normal;
}

.table {
  margin-bottom: 0;
}

.card {
  border: none;
  border-radius: 8px;
}
</style>
  